import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon } from "antd";
import { JobPost } from "../../../src/components/layouts/partials";
import {
    fetchJobDetailsBySlug,
    applyModalOpen,
    followCompany,
    favouriteGeneralStateChange,
    fetchRelatedJobs,
    favouriteModalOpen
} from "../../../src/store/actions";
import { redirect } from "../../../src/utils/redirect";
import { Socials } from "../../../src/components/layouts/partials/Socials";
import Link from "next/link";
import { GridBox, JobGrid, LogoGenerator } from '../../../src/components/common';
import { availabilityType } from '../../../src/utils/helpers';

class JobDetail extends Component {
    static async getInitialProps(ctx) {
        const { slug } = ctx.query;
        if (slug) {
            try {
                const job = await ctx.store.dispatch(fetchJobDetailsBySlug(ctx, slug, true, true));
                let related_jobs = [];
                if (job && job.post && job.post.id) {
                    related_jobs = await ctx.store.dispatch(fetchRelatedJobs({ ctx, category_id: job.post.category_id, job_id: job.post.id }));
                    related_jobs = related_jobs.data.related_jobs;
                }
                let { title, descriptions, company, category, job_location, availability } = ctx.store.getState().job.jobDetailPage;

                if (category.name) {
                    title = `${category.name} vacancy in ${job_location} | ${title} | Rojgari Sanjal`;
                }
                if (availability) {
                    availability = availabilityType(availability);
                }

                const meta_img = !company.logo || company.logo === 'https://rojal.s3.ap-south-1.amazonaws.com/rojal/logo/logo_placeholder.jpg' ? null : company.logo;


                return {
                    title: (title || 'Job Details'),
                    meta_desc: `Rojgari Sanjal is a free  job portal in Nepal. we offer ${category.name}  vacancy in ${job_location} ${availability} jobs in Nepal, ${category.name} jobs  in  Nepal`,
                    keywords: `${category.name}  vacancy in ${job_location}, ${category.name} vacancy in job Nepal, ${availability} jobs in nepal ,${availability} jobs in ${job_location}, ${title}`,
                    meta_img,
                    showFooter: true,
                    footerExtraPadding: 70,
                    related_jobs,
                }
            } catch (e) {
                redirect('/', ctx);
            }
        } else {
            redirect('/', ctx);
        }
    }

    render() {
        const { job, user, related_jobs } = this.props;
        const { applyState } = job;
        const details = job.jobDetailPage;
        return (<div>
            {details.is_expired ? <div className=" ant-alert ant-alert-error mock_warning">
                <div className="container">
                    <Icon type="close-circle" />&nbsp; <strong>Job Post has already been expired and hence apply
                        procedure has been disabled. Please search another job at rojgari sanjal. <Link
                            href={'/vacancies'}><a
                                href=""><u>Search Jobs</u></a></Link></strong>
                </div>
            </div> : null}

            <div className="tr-breadcrumb bg-image section-before">
                <div className="container">
                    <div className="breadcrumb-info text-center">
                        <div style={{ height: 'auto', borderRadius: 0 }} className="breadcrumb-logo">
                            {details.company.logo !== 'https://rojal.s3.ap-south-1.amazonaws.com/rojal/logo/logo_placeholder.jpg' ? <img
                                src={details.company ? details.company.logo : ''}
                                alt={details.company ? details.company.name : ''} /> : <LogoGenerator height={132} name={details.company.name} className="logo" />}

                        </div>

                        <div className="page-title">
                            <h1 style={{
                                marginBottom: 0,
                                color: 'white'
                            }}>
                                {details.company.name || 'Company Name'}
                            </h1>
                            <p>{details.company.slogan}</p>
                        </div>
                        <br />
                    </div>
                </div>
            </div>

            <div className="job-details section-padding">
                <div className="container">
                    <div className="row">
                        <div className={"col-md-12 " + (related_jobs.length < 1 ? 'col-lg-12' : 'col-lg-8')}>
                            {/*<div className="job-summary section">*/}
                            {/*<span*/}
                            {/*className="tr-title"><strong>ABOUT {details.company.name.toUpperCase()}</strong> </span>*/}
                            {/*<hr/>*/}
                            {/*<p>{details.company.about || 'Unavailable.'}</p>*/}
                            {/*</div>*/}

                            <JobPost apply={true} applyState={applyState} job={details} company={details.company}
                                applyAction={this.props.applyModalOpen} user={user.data} />
                        </div>
                        {related_jobs.length ? <div className="col-lg-4">
                            <div className="tr-sidebar">
                                <h3 className="widget_title">RELATED JOBS.</h3>
                                {related_jobs.map((item, key) => {
                                    return <GridBox
                                        href={`/job/detail/[slug]`}
                                        as={`/job/detail/${item.slug}`}
                                        key={key}
                                        image={item.company.logo}
                                        title={item.title} info={`Expires: ${item.expired_at.iso} (${item.expired_at.human})`}
                                        subTitle={item.job_location} />
                                })}
                                {/* <div className="widget cmpany-info">
                                    <h3 className="widget_title">COMPANY INFO.</h3>
                                    <ul className="tr-list">
                                        <li><span><i className="fa fa-home"
                                            aria-hidden="true" /></span>&nbsp;
                                                {details.company.name}
                                        </li>
                                        <li>
                                            <span>
                                                <i className="fa fa-map-marker" aria-hidden="true" />
                                            </span>
                                                &nbsp; {details.company.p_address}
                                        </li>
                                        <li>
                                            <span>
                                                <i className="fa fa-phone" aria-hidden="true" />
                                            </span>
                                                &nbsp; {details.company.phone}
                                        </li>
                                        <li><span><i className="fa fa-envelope" aria-hidden="true" /></span>&nbsp; <a
                                            href={"mailto:" + details.company.email}>{details.company.email}</a>
                                        </li>
                                        {details.company.domain ? <li>
                                            <span>
                                                <i className="fa fa-globe" aria-hidden="true" /></span>&nbsp;
                                                <a rel="noreferrer" target={'_blank'}
                                                href={'http://www.' + details.company.domain.replace(new RegExp('\\.*www.', 'gi'), '').replace(/^http?.:\/\//, '')}>{details.company.domain ? details.company.domain.toLowerCase() : 'N/A'}</a>
                                        </li> : null}
                                    </ul>
                                    <Socials socials={details.company.social} small={true} />
                                </div> */}
                            </div>
                        </div>
                            : null}
                    </div>
                </div>
            </div>

            {(user.data.ica === false && user.authCheck === true) || user.authCheck === false ?
                <div className="sticky_footer">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7 hidden-sm">
                                <h3><strong>{details.title}</strong></h3>
                                <small>{details.company.name.toUpperCase()}</small>
                            </div>
                            <div className="col-lg-5">
                                <a href="#"
                                    onClick={() => {
                                        this.props.applyModalOpen(details.title, details.id);
                                    }}
                                    className={"btn btn-primary big-on-sm " + (details.is_applied || details.is_expired ? ' disabled' : '')}
                                    style={{ float: 'right', marginLeft: 10 }}>
                                    {details.is_applied ? 'Applied' : 'Apply This Job'}
                                </a>&nbsp;&nbsp;&nbsp;&nbsp;
                                    <a href="#" onClick={() => {
                                    this.props.favouriteModalOpen({ favourite_type: 'JOB_MARKED_BY_USER', job_id: details.id });
                                    // this.props.favouriteGeneralStateChange({
                                    //     props: 'favourite_type',
                                    //     value: 'JOB_MARKED_BY_USER'
                                    // });
                                    // this.props.favouriteGeneralStateChange({
                                    //     props: 'favourite_job_id',
                                    //     value: details.id
                                    // });
                                    // this.props.favouriteGeneralStateChange({ props: 'favouriteModal', value: true });
                                }}
                                    className={"btn btn-outlined big-on-sm " + (details.is_bk_m || details.is_expired ? ' disabled' : '')}
                                    style={{ float: 'right' }}>
                                    {details.is_bk_m ? 'Added to Favourite' : 'Add to Favourite'}
                                </a>
                            </div>
                        </div>
                    </div>
                </div> : null}
        </div>
        );
    }

}

const mapStateToProps = state => {
    return {
        job: state.job,
        user: state.user,
    }
};


export default connect(mapStateToProps, { applyModalOpen, followCompany, favouriteGeneralStateChange, favouriteModalOpen })(JobDetail);